import styled from 'styled-components'

export const GuideButtonsContainer = styled.div`
  display: flex;
  justify-content: flex-end;
`
